import { render } from "./CoreBizView.vue?vue&type=template&id=9efa7c32&scoped=true&ts=true"
import script from "./CoreBizView.vue?vue&type=script&lang=ts"
export * from "./CoreBizView.vue?vue&type=script&lang=ts"

import "./CoreBizView.vue?vue&type=style&index=0&id=9efa7c32&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9efa7c32"]])

export default __exports__